import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import './NewMessage.css'
import MessageTicket from '../MessageTicket/MessageTicket';
import AttachTicket from '../AttachTicket/AttachTicket';

const NewMessage = (props) => {
    const { user, ticket, setTicket, textoRes, setTextoRes, adjuntoRes, setAdjuntoRes, flagAdjuntoRes, setFlagAdjuntoRes, setFlagTextoRes } = props

    return (
        <div className = 'container-fluid' style = {{display: ticket.estado == 'PENDIENTE' || ticket.estado == 'PROCESO' ? '' : 'none'}}>
            <div className = 'row' style={{margin: "2px 5px 8px 0px"}}>
                <MessageTicket user = {user} ticket = {ticket} setTicket = {setTicket} textoRes = {textoRes} setTextoRes = {setTextoRes} setFlagTextoRes = {setFlagTextoRes}/>
                <AttachTicket user = {user} adjuntoRes = {adjuntoRes} setAdjuntoRes = {setAdjuntoRes} flagAdjuntoRes={flagAdjuntoRes} setFlagAdjuntoRes={setFlagAdjuntoRes}/>
            </div>
        </div>
    )
}

export default NewMessage;